'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _spauiUtils = require('@tencent/spaui-utils');

var _info = require('./info');

var _info2 = _interopRequireDefault(_info);

var _watermark_props = require('./watermark_props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Tencent is pleased to support the open source community by making SPA UI available.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Copyright (C) 2019, a Tencent company. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

/**
 * @fileOverview 水印组件
 * @author kirkzheng
 * @time 2017-12-25
 * @module @tencent/spaui-watermark
 */

/**
 * @class
 */
var Watermark = function (_PureComponent) {
    _inherits(Watermark, _PureComponent);

    function Watermark() {
        _classCallCheck(this, Watermark);

        return _possibleConstructorReturn(this, (Watermark.__proto__ || Object.getPrototypeOf(Watermark)).apply(this, arguments));
    }

    _createClass(Watermark, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
                (0, _spauiUtils.checkCssVersion)(_info2.default);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var url = this.props.url;


            return _react2.default.createElement('div', (0, _spauiUtils.globalProps)(this.props, {
                className: 'spaui-watermark',
                style: {
                    backgroundImage: 'url(' + url + ')'
                }
            }, Watermark, this.props));
        }
    }]);

    return Watermark;
}(_react.PureComponent);

// 组件标记与上报


Watermark.propTypes = _watermark_props.propTypes;
Watermark.defaultProps = _watermark_props.defaultProps;
(0, _spauiUtils.setComponentMark)(Watermark, _info2.default, function () {
    (0, _spauiUtils.reportComponentUsage)(_extends({
        scope: 'spaui'
    }, _info2.default));
});

exports.default = Watermark;